define('areas/widgetmanager/viewmodels/index',["require", "exports", 'durandal/app', "services/settings"], function (require, exports, app, Configuration) {
    "use strict";
    var AddWidgetVM = (function () {
        function AddWidgetVM() {
            this.widgetList = [];
            this.zeroState = false;
        }
        AddWidgetVM.prototype.showAddWidgetsPopUp = function (_shell) {
            this._shell = _shell;
            app.showDialog(this); // locate html file through durandal dialog mechanism
            for (var i = 0; i < _shell.groupedNavigationItems.length; i++) {
                if (_shell.groupedNavigationItems[i].key === _shell.sidebar.current) {
                    for (var j = 0; j < _shell.groupedNavigationItems[i].list.length; j++) {
                        if (_shell.groupedNavigationItems[i].list[j].isHidden) {
                            _shell.groupedNavigationItems[i].list[j].addWidgetBack = false;
                            _shell.groupedNavigationItems[i].list[j].toggleDescription = false;
                            this.widgetList.push(_shell.groupedNavigationItems[i].list[j]);
                        }
                    }
                    break;
                }
            }
            if (this.widgetList.length == 0) {
                this.zeroStateImagePath = Configuration.Settings.environment.getCustomValue("CdnEndPoint") + "content/images/add-widgets-zero-state.png";
                this.zeroState = true;
            }
            ko.track(this, ["widgetList", "_shell", "zeroState", "zeroStateImagePath"]);
        };
        AddWidgetVM.prototype.closeAddWidgetsPopUp = function () {
            app.closeDialog(this);
        };
        AddWidgetVM.prototype.saveChanges = function () {
            for (var i = 0; i < this.widgetList.length; i++) {
                this.widgetList[i].isHidden = !this.widgetList[i].addWidgetBack;
            }
            this._shell.saveUserSettingsChanges();
            this.closeAddWidgetsPopUp();
        };
        return AddWidgetVM;
    }());
    return AddWidgetVM;
});

